import { render, staticRenderFns } from "./EmailListItem.vue?vue&type=template&id=75130812&scoped=true&"
import script from "./EmailListItem.vue?vue&type=script&lang=js&"
export * from "./EmailListItem.vue?vue&type=script&lang=js&"
import style0 from "./EmailListItem.vue?vue&type=style&index=0&id=75130812&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75130812",
  null
  
)

export default component.exports